import { connect } from 'react-redux';
import { closeInCallModal } from 'actions/InCallModal';
import SharingPermissionsModal from 'components/SharingPermissionsModal/SharingPermissionsModal';

const mapStateToProps = (state) => {
  const i18nMessages = state.app.i18n.messages;
  return {
    i18nMessages
  };
};

const mapDispatchToProps = dispatch => ({
  closeInCallModal: () => dispatch(closeInCallModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(SharingPermissionsModal);
